import Input from "@Common/input"
import { PhoneNumberField } from "@Common/PhoneNumberField"
import { Checkbox } from "@mui/material"
import { isValidPhone } from "@utils"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FormInputsServiceProviderWrapper } from "./styles"
import { LoadingWrapper } from "@components"
import { useGetGetListServiceProviderServices } from "@services"
import { useMemo } from "react"

export default function FormInputsServiceProvider() {
	const {
		t,
		i18n: { language },
	} = useTranslation()
	const { control } = useFormContext()

	/* ---------------------------------- API'S --------------------------------- */
	const { data } = useGetGetListServiceProviderServices({})

	const roleList = useMemo(() => {
		return (
			data?.result.map((item) => ({
				id: item.id,
				label: language === "ar" ? item.nameAr : item.name,
				value: item.id.toString(),
			})) ?? []
		)
	}, [data])

	return (
		<LoadingWrapper loading={false}>
			<FormInputsServiceProviderWrapper>
				<Input
					label={t("UserManagement.name")}
					placeholder={t("UserManagement.name")}
					name='fullName'
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
					}}
				/>
				<Controller
					name='phoneNumber'
					control={control}
					rules={{
						required: t("COMMON.REQUIRED"),
						validate: (value) =>
							isValidPhone(value) ||
							t("UserManagement.please_enter_the_mobile_number_correctly"),
					}}
					render={({
						field: { value, onChange, onBlur },
						fieldState: { error },
					}) => (
						<PhoneNumberField
							value={value}
							onChange={onChange}
							onBlur={onBlur}
							required
							label={t("UserManagement.phone_number")}
							placeholder={t("UserManagement.phone_number")}
							error={error?.message ? t(error.message) : undefined}
						/>
					)}
				/>
				<div className='containerCheckBox'>
					<p>{t("UserManagement.team_member_role")}</p>
					<div className='conatinerCheckbox'>
						<Controller
							name='selectedServices'
							control={control}
							defaultValue={[]}
							render={({ field }) => (
								<>
									{roleList.map((item) => {
										const isChecked = field.value.includes(item.value)

										return (
											<div key={item.id} className='itemCheckbox'>
												<Checkbox
													checked={isChecked}
													value={item.value}
													onChange={(e) => {
														const newValue = e.target.value
														const isChecked = e.target.checked
														const updatedValues = isChecked
															? [...field.value, newValue]
															: field.value.filter(
																	(val: any) => val !== newValue
																)

														field.onChange(updatedValues)
													}}
												/>
												<p>{item.label}</p>
											</div>
										)
									})}
								</>
							)}
						/>
					</div>
				</div>
			</FormInputsServiceProviderWrapper>
		</LoadingWrapper>
	)
}
